<div class="flex justify-center pt-6 pb-2 px-4">
    <div class="rounded-full p-4 flex items-center justify-center"
         [ngClass]="success ? 'bg-success' : 'bg-error'">
        @if (success) {
            <app-icon icon="app:check" size="xl" class="text-white" />
        } @else {
            <app-icon icon="app:close" size="xl" class="text-white" />
        }
    </div>
</div>

<div class="modal-body text-center">

    @if (success) {
        <h2 class="card-heading-lg text-success mb-2">
            {{ 'applied_coupon.success_title' | translate }}
        </h2>
        <p class="text-sm opacity-60"
           [innerHTML]="'applied_coupon.success_description' | translate: { discountValue: discountValue }">
        </p>
    } @else {
        <h2 class="card-heading-lg text-error mb-2">
            {{ 'applied_coupon.error_title' | translate }}
        </h2>
        <p class="text-sm opacity-60">
            {{ 'applied_coupon.error_description' | translate }}
        </p>
    }

</div>

<div class="flex flex-col gap-1 px-4 pb-4 pt-2">

    <button type="button"
            class="btn w-full py-3 font-semibold flex items-center justify-center gap-2"
            [ngClass]="success ? 'btn-primary' : 'btn-error'"
            (click)="navigateToSubscription()">
        <app-icon icon="app:premium" size="md" />
        @if (success) {
            {{ 'applied_coupon.btn_continue_subscription' | translate }}
        } @else {
            {{ 'applied_coupon.btn_show_offers' | translate }}
        }
    </button>

    <button type="button"
            class="btn btn-ghost text-sm opacity-60 w-full"
            (click)="close()">
        {{ 'applied_coupon.btn_later' | translate }}
    </button>

</div>
